import { createContext } from 'react'
import { BriefState } from '../../Hooks/Brief/useBrief/useBrief'

const BriefContext = createContext<BriefState | undefined>(undefined)

export default BriefContext
